import React from 'react'
import FuboFreeTemplate from 'src/components/template/fubofree'
import { leagueIds, PlanTypes, sportIds } from 'src/constants'
import { useIsRSNAvailable } from 'src/modules/hooks/useIsRSNAvailable'
import { networkLogos } from 'src/constants/networkLogos'
import { videoURI } from 'src/modules/utils/constants'
import { usPlanData } from 'src/constants/planData/usPlanData'
export default (props) => {
  const { isAvailable } = useIsRSNAvailable(PlanTypes.CHICAGO_SPORTS_NETWORK)

  return (
    <FuboFreeTemplate
      location={props.location}
      video={videoURI + 'compressed/ChicagoSN_LP_10s_16x9_V2.mp4'}
      videoMobile={videoURI + 'mobile/ChicagoSN_LP_10s_1x1_V2.mp4'}
      staticAnnotation={networkLogos.chsn}
      title="Stream Chicago Sports Network"
      subtitle="Watch the White Sox, Bulls & Blackhawks without cable"
      networkSet="baseball"
      customNetworks={['chsn']}
      sportId={sportIds.Baseball}
      leagueId={leagueIds.MLB}
      hasPlanCards={isAvailable}
      plans={[usPlanData.chicago_sports_network_monthly, usPlanData.pro_standalone_monthly]}
      plansSharedData={{
        teams: usPlanData.chicago_sports_network_monthly.teams,
      }}
      additionalFAQs={additionalFAQs}
    />
  )
}

const additionalFAQs = [
  {
    question: 'How can I find Chicago Bulls games on Fubo?',
    answer:
      'To find Chicago Bulls games on Fubo, use the search feature or check the schedule for Chicago Sports Network, which broadcasts Bulls games live.',
  },
  {
    question: 'Where can I watch Chicago Blackhawks games without cable?',
    answer:
      'You can watch Chicago Blackhawks games without cable on Fubo via Chicago Sports Network, which provides live coverage of Bulls games.',
  },
  {
    question: 'Can I watch MLB games on Fubo?',
    answer:
      'Yes, Fubo offers MLB games through channels like ESPN and regional sports networks, allowing you to enjoy live baseball action throughout the season.',
  },
  {
    question: 'How do I find Chicago White Sox games on Fubo?',
    answer:
      'To find Chicago White Sox games on Fubo, check the schedule for Chicago Sports Network where you can watch live broadcasts of the games.',
  },
  {
    question: 'Does Fubo provide commentary and analysis for NBA games?',
    answer:
      'Yes, Fubo includes channels that offer commentary and analysis for NBA games, enhancing your viewing experience with expert insights.',
  },
  {
    question: 'Can I watch pre-game and post-game shows for the Chicago Bulls on Fubo?',
    answer:
      'Yes, Fubo provides access to pre-game and post-game shows for the Chicago Bulls on Chicago Sports Network, giving you comprehensive coverage of each game.',
  },
  {
    question: 'Are there any related shows for Chicago sports on Fubo?',
    answer:
      'Yes, Fubo offers various related shows and analysis programs for Chicago sports, available on channels including Chicago Sports Network, ensuring you stay updated on your favorite teams.',
  },
]
